import React, { useState, useEffect, useMemo } from "react";
import { styled, useTheme } from "@mui/material/styles";
import "react-datepicker/dist/react-datepicker.css";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import LiquidFillGauge from "react-liquid-gauge";
import { Helmet } from 'react-helmet';
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CommonAlert, { GetuserDatavalue } from "../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { style } from "@mui/system";
import { Tooltip, Typography } from "@mui/material";
import Loader from "../CommonLoader";
import { Container, Grid, Box } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import WarningCount from "../Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from "../Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Chart from "react-apexcharts";
import Commoncard from "../Commoncard";



export default function BackLinksSummary(props) {
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = useState("1");
  const [chartvalue, setChartvalue] = useState("4");
  const esodata = useSelector((state) => state);
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    "current_trend": {
      "growth": 0,
      "status": "up",
      "percentage": "0.00%"
    },
    "market_benchmark": {
      "average_da": 0,
      "total_competitors": 0
    },
    "low_5_performers": [],
    "top_5_performers": [],
    "last_7_jobs_trend": [],
  });
  const navigate = useNavigate();
  const ApiToken = esodata.apiauthkey.value;


  const apihandleClose = () => {
    setapiOpen(false);
  };



  const columns = [
    {
      field: "headkey",
      headerName: "Domain Name",
      minWidth: 160,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      renderHeader: () => (
        <Tooltip
          title="Name of the domain and their competitors."
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "rgba(97, 97, 97, 0.92)",
                marginLeft: "50px",
              }
            }
          }}
        >
          <span style={{ fontFamily: "Poppins, sans-serif", fontSize: "15px", fontWeight: "500" }}>
            Domain Name
          </span>
        </Tooltip>
      )
    },
    {
      field: "domain_authority",
      headerName: "Domain Authority",
      minWidth: 200,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "The overall authority score of the root domain, based on its backlink profile.",
      renderCell: (cardData) => {
        var sr = cardData.row.domain_authority;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: '#0b2033',
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
          />
        );
      },
    },
    {
      field: "page_authority",
      headerName: "Page Authority",
      minWidth: 170,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "The authority score of the specific URL, reflecting its backlink strength.",
      renderCell: (cardData) => {
        var sr = cardData.row.page_authority;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: "#0b2033",
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
            }}
          />
        );
      },
    },
    {
      field: "total_backlinks",
      headerName: "Total Backlinks",
      minWidth: 170,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "The total number of external links pointing to site.",
    },
    {
      field: "total_referring_domains",
      headerName: "Total Referring Domains",
      minWidth: 250,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Number of unique domains linking to the site.",
    },
    {
      field: "total_referring_ips",
      headerName: "Total Referring IPs",
      minWidth: 200,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Number of unique IPs linking to the site.",
    },
    {
      field: "follow_links",
      headerName: "Follow Vs No-Follow Links",
      minWidth: 270,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Breakdown of backlinks that pass SEO value (follow) vs. those that don’t (nofollow).",
      renderCell: (cardData) => {
        return (

          <div>

            <div className=" dt-left" id="td-backlink-0" data-sort={1}>
              <span>Follow {'('}{cardData.row.follow_links}{')'}</span>
              <div className="stacked-bar-graph">
                <span style={{ width: cardData.row.follow_linksp }} className="bardata" />
              </div>
            </div>

            <div className=" dt-left" id="td-backlink-0" data-sort={1}>
              <span>No follow  {'('}{cardData.row.nofollow_links}{')'}</span>
              <div className="stacked-bar-graph">
                <span style={{ width: cardData.row.nofollow_linksp }} className="bardata white" />
              </div>



            </div>

          </div>

        );
      },
    },
    {
      field: "edu_backlinks",
      headerName: "Educational Website Backlinks",
      minWidth: 300,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Number of backlinks from educational (.edu) websites.",

    },

    {
      field: "gov_backlinks",
      headerName: "Government Website Backlinks",
      minWidth: 300,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Number of backlinks from government (.gov) websites.",
    },
    {
      field: "top_ten_refdomains",
      headerName: "Top 10 Referring Domains",
      minWidth: 250,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "The top 10 unique domains linking to a target.",
    },
    {
      field: "new_backlinks",
      headerName: "Count Of New Backlinks",
      minWidth: 250,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Number of new backlinks discovered since the last check.",
    },
    {
      field: "lost_backlinks",
      headerName: "Count Of Lost Backlinks",
      minWidth: 250,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Number of backlinks that were removed or became inactive.",

    }
  ]
  const [validation, setValidation] = useState({
    dateerror: "",
  });
  const rows = cardData ?? [];
  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    callUserdataApi();
  }, []);

  useEffect(() => {
    if (props.FilterButtonTriggered === true) {
      callUserdataApi()
      props.SetFilterButtonTriggered(false)
      props.closeModal()
    }
  }, [props])

  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);
    var JobId = '';
    if (props.RankJob) {
      if (props.RankJob.value) {
        JobId = props.RankJob.value
      }
    }
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });
      var RowValues = [];
      if (datavalue) {
        if (datavalue?.data) {
          if (datavalue?.data?.domain_names) {
            var DomainNames = datavalue.data.domain_names;
            var domain_authority = [];
            var page_authority = [];
            var total_backlinks = [];
            var total_referring_domains = [];
            var total_referring_ips = [];
            var follow_links = [];
            var nofollow_links = [];
            var follow_linksp = [];
            var nofollow_linksp = []
            var edu_backlinks = [];
            var gov_backlinks = [];
            var top_ten_refdomains = [];
            var new_backlinks = [];
            var lost_backlinks = [];
            if (datavalue.data.table.domain_authority) {
              domain_authority = datavalue.data.table.domain_authority
            }
            if (datavalue.data.table.page_authority) {
              page_authority = datavalue.data.table.page_authority
            }
            if (datavalue.data.table.total_backlinks) {
              total_backlinks = datavalue.data.table.total_backlinks
            }
            if (datavalue.data.table.total_referring_domains) {
              total_referring_domains = datavalue.data.table.total_referring_domains
            }
            if (datavalue.data.table.total_referring_ips) {
              total_referring_ips = datavalue.data.table.total_referring_ips
            }
            if (datavalue.data.table.follow_links) {
              follow_links = datavalue.data.table.follow_links
            }
            if (datavalue.data.table.nofollow_links) {
              nofollow_links = datavalue.data.table.nofollow_links
            }
            if (datavalue.data.table.follow_links_percentage) {
              follow_linksp = datavalue.data.table.follow_links_percentage
            }
            if (datavalue.data.table.nofollow_links_percentage) {
              nofollow_linksp = datavalue.data.table.nofollow_links_percentage
            }
            if (datavalue.data.table.edu_backlinks) {
              edu_backlinks = datavalue.data.table.edu_backlinks
            }
            if (datavalue.data.table.gov_backlinks) {
              gov_backlinks = datavalue.data.table.gov_backlinks
            }
            if (datavalue.data.table.top_ten_refdomains) {
              top_ten_refdomains = datavalue.data.table.top_ten_refdomains
            }
            if (datavalue.data.table.new_backlinks) {
              new_backlinks = datavalue.data.table.new_backlinks
            }
            if (datavalue.data.table.lost_backlinks) {
              lost_backlinks = datavalue.data.table.lost_backlinks
            }
            DomainNames.forEach((element, index) => {
              RowValues.push({
                id: index,
                headkey: element,
                domain_authority: domain_authority[element],
                page_authority: page_authority[element],
                total_backlinks: total_backlinks[element],
                total_referring_domains: total_referring_domains[element],
                total_referring_ips: total_referring_ips[element],
                follow_links: follow_links[element],
                nofollow_links: nofollow_links[element],
                follow_linksp: follow_linksp[element],
                nofollow_linksp: nofollow_linksp[element],
                edu_backlinks: edu_backlinks[element],
                gov_backlinks: gov_backlinks[element],
                top_ten_refdomains: top_ten_refdomains[element],
                new_backlinks: new_backlinks[element],
                lost_backlinks: lost_backlinks[element]
              })

            });
            if (RowValues && RowValues.length > 0) {
              const newData = RowValues.map((obj, index) => {
                return { ...obj, sid: index + 1 };
              });
              setCardData(newData);
              SetAutoheightval(false)
            }
            else {
              setCardData("");
              SetAutoheightval(true)
            }
            if (datavalue?.data?.job_date)
              props.setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
            else
              props.setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"));
          }
          setSummaryData({
            "current_trend": {
              "growth": datavalue?.data?.charts?.current_trend?.growth || 0,
              "status": datavalue?.data?.charts?.current_trend?.status || "up",
              "percentage": datavalue?.data?.charts?.current_trend?.percentage || "0.00%"
            },
            "market_benchmark": {
              "average_da": datavalue?.data?.charts?.market_benchmark?.average_da || 0,
              "total_competitors": datavalue?.data?.charts?.market_benchmark?.total_competitors || 0
            },
            "low_5_performers": datavalue?.data?.charts?.low_5_performers || [],
            "top_5_performers": datavalue?.data?.charts?.top_5_performers || [],
            "last_7_jobs_trend": datavalue?.data?.charts?.last_7_jobs_trend || [],
          });
        }
      }
    } catch (err) {
      console.log(err)
    }
    setTableLoading(false);
    setLoading(false);
  };
  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];
  const handleModelPopUp = () => {
    props.openModal();
  }

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }

  const cardDatas = [
    {
      value: summaryData.current_trend.growth || 0,
      title: "Growth",
      // badge: "SEO",
      iconSrc: ErrorCount,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: summaryData.current_trend.percentage || 0,
      title: "Percentage",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 2,
      bgColor: 2,
    },
    {
      value: summaryData.current_trend.status || 0,
      title: "Status",
      // badge: "SEO",
      iconSrc: ErrorCount,
      iconColor: 3,
      bgColor: 3,
    },
    {
      value: summaryData.market_benchmark.average_da || 0,
      title: "Average DA",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 4,
      bgColor: 4,
    },
    {
      value: summaryData.market_benchmark.total_competitors || 0,
      title: "Total Competitors",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 1,
      bgColor: 1,
    },

  ];



  return (
    <div >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Backlinks Summary</title>
      </Helmet>
      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          <Grid container spacing={3} xs={12} sm={12} md={12} justifyContent="center">
            {cardDatas.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Commoncard
                  item={item}
                  nonclikable={true}
                />
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Top 5 Performers</Typography>
              <Chart
                type="bar"
                height={250}
                series={[{ name: "DA", data: summaryData?.top_5_performers.map(i => i.da) }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                  colors: ["#2e7d32"],
                  xaxis: { categories: summaryData?.top_5_performers.map(i => i.name), labels: { show: false } },
                  dataLabels: { enabled: true, formatter: (val) => `${val}`, position: 'right' },
                  tooltip: {
                    custom: ({ dataPointIndex }) => {
                      const item = summaryData?.top_5_performers[dataPointIndex];
                      return `
          <div style="padding:8px 10px;">
            <strong>${item.name}</strong><br/>
            DA: ${item.da}<br/>
            Backlinks: ${item.backlinks}%
          </div>
        `;
                    },
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Low 5 Performers</Typography>
              <Chart
                type="bar"
                height={250}
                series={[{ name: "DA", data: summaryData?.low_5_performers.map(i => i.da) }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                  colors: ["#8e1616"],
                  xaxis: { categories: summaryData?.low_5_performers.map(i => i.name), labels: { show: false } },
                  dataLabels: { enabled: true, formatter: (val) => `${val}`, position: 'right' },
                  tooltip: {
                    custom: ({ dataPointIndex }) => {
                      const item = summaryData?.low_5_performers[dataPointIndex];
                      return `
          <div style="padding:8px 10px;">
            <strong>${item.name}</strong><br/>
            DA: ${item.da}<br/>
            Backlinks: ${item.backlinks}%
          </div>
        `;
                    },
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Last 7 Job Trend</Typography>
              <Chart
                type="area"
                height={250}
                series={[
                  {
                    name: "Score",
                    // data: [4, 5, 6, 6, 77]
                    data: summaryData?.last_7_jobs_trend.map(i => i.count)
                  }
                ]}
                options={{
                  chart: {
                    toolbar: { show: false }
                  },
                  colors: ["#ff601f"],
                  stroke: { curve: 'smooth', width: 3 },
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shadeIntensity: 1,
                      opacityFrom: 0.4,
                      opacityTo: 0.1
                    }
                  },
                  xaxis: {
                    // categories: ['Apr 12', 'Apr 13', 'Apr 14', 'Apr 15', 'Apr 16'],
                    categories: summaryData.last_7_jobs_trend.map(i =>
                      new Date(i.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                    ),
                    tickPlacement: 'on', // 🔥 important
                    labels: {
                      offsetX: 50 // 👈 manual adjustment
                    }
                  },
                  yaxis: {
                    min: 0,
                    max: function (max) {
                      return max === 0 ? 10 : Math.ceil(max * 1.2);
                    },
                    tickAmount: 4,
                  },
                                    grid: {
                    padding: { left: 0, right: 0 }
                  }
                }}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 160]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <div >


        {/* <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={2}
          columnFreezeWidth={[0, 160]}
          tableLoading={tableLoading}
        /> */}
        {!openCommonAlerts &&
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        }
        <UserActivityTracker pagename="Backlinks - Backlinks Summary" />
      </div>

    </div>
  );
}
